package app.svg

import dev.fritz2.core.RenderContext

fun RenderContext.sun(className: String) {
    svg(className) {
        attr("aria-hidden", "true")
        attr("xmlns", "http://www.w3.org/2000/svg")
        attr("width", "24")
        attr("height", "24")
        attr("fill", "none")
        attr("viewBox", "0 0 24 24")

        path {
            attr("stroke", "currentColor")
            attr("stroke-linecap", "round")
            attr("stroke-linejoin", "round")
            attr("stroke-width", "2")
            attr(
                "d",
                "M12 5V3m0 18v-2M7.05 7.05 5.636 5.636m12.728 12.728L16.95 16.95M5 12H3m18 0h-2M7.05 16.95l-1.414 1.414M18.364 5.636 16.95 7.05M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
            )
        }
    }
}
